import { FormattedMessage } from "react-intl";
import { reports } from "./reports";

export const analyticalReport = {
  label: <FormattedMessage id="Adoption_Report" />,
  path: (tenantName) => `/${tenantName}/reports/analyticalReport`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
    {
      key: 2,
      label: <FormattedMessage id="ANALYTICAL_REPORTS" />,
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
  ],
  graphs: (data1, data2, data3, data4, data5) => [
    {
      key: 1,
      type: "horizontalBar",
      heading: "Shotclasses Properties",
      xAxesText: "",
      yAxesText: "",
      data: data1,
    },
    {
      key: 2,
      type: "horizontalBar",
      heading: <FormattedMessage id="SHOTCLASSES_ANALYTICAL_REPORT_CONTENT_TYPE" />,
      xAxesText: "",
      yAxesText: "",
      data: data2,
    },
    {
      key: 3,
      type: "doughnut",
      heading: <FormattedMessage id="ANALYTICAL_REPORTS" />,
      xAxesText: "",
      yAxesText: "",
      data: data3,
    },
    {
      key: 4,
      type: "horizontalBar",
      heading: <FormattedMessage id="ANALYTICAL_REPORT_RATING" />,
      xAxesText: "",
      yAxesText: "",
      data: data4,
    },
    {
      key: 5,
      type: "doughnut",
      heading: <FormattedMessage id="ANALYTICAL_REPORT_TRAINING_STATUS" />,
      xAxesText: "",
      yAxesText: "",
      data: data5,
    },
  ],
  inputField: (formArgs) => [
    {
      key: 1,

      type: "tags",
      name: "userGroup",
      label: "Users Group",

      fieldValue: "UserGroupId",
      setSelectedId: formArgs.setUserGroupId,
      placeholder: "Select User Groups",
      searchTagsList: formArgs.searchGroupTagsList,
      onChange: (e) => formArgs.onUserGroupSearch(e),
    },
    {
      key: 2,
      type: "tags",
      name: "className",
      fieldValue: "ID",
      label: "Select Classes",
      defaultValue: formArgs.selectedClassName,
      placeholder: "Select Shotclasses",
      setSelectedId: formArgs.setClassId,
      searchTagsList: formArgs.searchClassTagsList,
      onChange: (e) => formArgs.onClassSearch(e),
    },
    {
      key: 3,
      type: "reset",
      onClick: (e) => formArgs.handleReset(e),
    },
    // {
    //   key: 4,
    //   type: "searchBtn",
    //   onClick: (e) => formArgs.onFilterSearch(e),
    // },
  ],
};
